import axios from "axios";
import API_BASE_URL from "../../config/api";

const API_ENDPOINT = API_BASE_URL;

// Pobieranie nagłówków z tokenem
const getHeaders = async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Token is not available");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

// Funkcja do przesyłania danych podziału
export const submitSplitData = async ({
  originalTicketId,
  nrRef,
  splits,
  ticketData,
}) => {
  try {
    const headers = await getHeaders();

    const payload = {
      originalTicketId,
      nrRef,
      splits,
      ticketData,
    };

    const response = await axios.post(`${API_ENDPOINT}/saveSplit`, payload, {
      headers,
    });

    return response.data;
  } catch (error) {
    console.error("Błąd przy zapisie podziału:", error);
    throw error;
  }
};

// Funkcja do sprawdzania istnienia SAD w bazie
export const checkSadExists = async (sadValue) => {
  try {
    const headers = await getHeaders();

    const response = await axios.post(
      `${API_ENDPOINT}/checkSad`,
      { sad: sadValue },
      { headers },
    );

    return response.data; // oczekiwane: { exists: boolean, nrRef?: string }
  } catch (error) {
    console.error("Błąd przy sprawdzaniu SAD:", error);
    return { exists: false };
  }
};
